import {
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import CancelIcon from '@mui/icons-material/Cancel';

export default function GastosTable({ gastos, onEdit, onAnular }) {
  return (
    <Table size="small">
      <TableHead>
        <TableRow>
          <TableCell>Fecha</TableCell>
          <TableCell>Concepto</TableCell>
          <TableCell>Categoría</TableCell>
          <TableCell>Monto</TableCell>
          <TableCell>Estado</TableCell>
          <TableCell />
        </TableRow>
      </TableHead>

      <TableBody>
        {gastos.map(g => (
          <TableRow
            key={g.id}
            sx={{
              textDecoration: g.estado === 'ANULADO' ? 'line-through' : 'none',
              opacity: g.estado === 'ANULADO' ? 0.5 : 1
            }}
          >
            <TableCell>{g.fecha}</TableCell>
            <TableCell>{g.concepto}</TableCell>
            <TableCell>{g.categoria}</TableCell>
            <TableCell>{g.monto}</TableCell>
            <TableCell>{g.estado}</TableCell>
            <TableCell>
              <IconButton onClick={() => onEdit(g)}>
                <EditIcon />
              </IconButton>

              {g.estado === 'ACTIVO' && (
                <IconButton
                  color="error"
                  onClick={() => {
                    const motivo = prompt('Motivo de anulación');
                    if (motivo) onAnular(g.id, motivo);
                  }}
                >
                  <CancelIcon />
                </IconButton>
              )}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
